export default __webpack_public_path__ + "static/media/printer.e01a086a.svg";